module.exports = __webpack_public_path__ + "img/f.d5e53b61.svg";